module.exports = __webpack_public_path__ + "img/logo-wedi.e3b985ea.png";